import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Navbar from '@/components/Navbar';
import HomePage from '@/pages/HomePage';
import BatchesPage from '@/pages/BatchesPage';
import BatchDetailPage from '@/pages/BatchDetailPage';
import RecipesPage from '@/pages/RecipesPage';
import RecipeDetailPage from '@/pages/RecipeDetailPage';
import InventoryPage from '@/pages/InventoryPage';
import DashboardPage from '@/pages/DashboardPage';
import LoginPage from '@/pages/LoginPage';
import Footer from '@/components/Footer';
import NotFoundPage from '@/pages/NotFoundPage';
import RequireAuth from '@/components/RequireAuth';
import AIAssistantPage from '@/pages/AIAssistantPage';
import BrewfatherSetupPage from '@/pages/BrewfatherSetupPage';
import OpenAISetupPage from '@/pages/OpenAISetupPage';
import PricingPage from '@/pages/PricingPage';
import TermsPage from '@/pages/TermsPage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPage from '@/pages/PrivacyPage';

const App: React.FC = () => {
	return (
		<>
			<Navbar />
			<Box component="main">
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/batches" element={<RequireAuth><BatchesPage /></RequireAuth>} />
					<Route path="/batches/:id" element={<RequireAuth><BatchDetailPage /></RequireAuth>} />
					<Route path="/recipes" element={<RequireAuth><RecipesPage /></RequireAuth>} />
					<Route path="/recipes/:id" element={<RequireAuth><RecipeDetailPage /></RequireAuth>} />
					<Route path="/inventory" element={<RequireAuth><InventoryPage /></RequireAuth>} />
					<Route path="/ai-assistant" element={<RequireAuth><AIAssistantPage /></RequireAuth>} />
					<Route path="/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
					<Route path="/brewfather-setup" element={<RequireAuth><BrewfatherSetupPage /></RequireAuth>} />
					<Route path="/openai-setup" element={<RequireAuth><OpenAISetupPage /></RequireAuth>} />
					<Route path="/pricing" element={<PricingPage />} />
					<Route path="/terms" element={<TermsPage />} />
					<Route path="/privacy" element={<PrivacyPage />} />
					<Route path="/contact" element={<ContactPage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/404" element={<NotFoundPage />} />
					<Route path="*" element={<Navigate to="/404" replace />} />
				</Routes>
			</Box>
			<Footer />
		</>
	);
};

export default App;
